// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import PrintedBlindsContent from './PageComponent/PrintedBlindsContent'

function PrintedBlinds() {

    useMeta({
        title: 'Printed Blinds enlighten your space with its colour, design & texture',
        description: 'Callistus Blinds provides a huge range of printed blinds which can match your interior and enhance your room ; you name it we have it',
        canonical: 'https://callistusblinds.com/printed-blinds/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Printed Blinds enlighten your space with its colour, design & texture',
            description:
                'Callistus Blinds provides a huge range of printed blinds which can match your interior and enhance your room ; you name it we have it',
            url: 'https://callistusblinds.com/printed-blinds/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <PrintedBlindsContent />
            <Footer />
        </div>
    );
}

export default PrintedBlinds;
